import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge } from "@/components/StatusBadge";
import { CancelDialog } from "@/components/CancelDialog";
import { prettyDate, slotById } from "@/lib/studio";

const Row = ({ b, onCancel }) => (
  <TableRow className="border-white/5 hover:bg-white/[0.02]" data-testid={`admin-booking-row-${b.id}`}>
    <TableCell className="whitespace-nowrap font-tech text-sm text-white">{prettyDate(b.date)}</TableCell>
    <TableCell className="whitespace-nowrap font-tech text-xs text-zinc-300">{slotById(b.slot)?.time}</TableCell>
    <TableCell className="text-sm text-zinc-300">{b.space || "—"}</TableCell>
    <TableCell>
      <p className="text-sm text-white">{b.user_name}</p>
      {b.kind === "class" ? (
        <span className="font-tech text-[10px] uppercase tracking-[0.2em] text-[#00F0FF]" data-testid={`admin-class-tag-${b.id}`}>Class booking</span>
      ) : (
        <p className="text-xs text-zinc-500">{b.user_email}</p>
      )}
    </TableCell>
    <TableCell className="max-w-[220px] truncate text-sm text-zinc-400" title={b.notes}>{b.notes || "—"}</TableCell>
    <TableCell><StatusBadge status={b.status} testId={`admin-booking-status-${b.id}`} /></TableCell>
    <TableCell className="text-right">
      {b.status === "confirmed" && (
        <CancelDialog
          testId={`admin-cancel-${b.id}`}
          description={`${b.user_name} · ${prettyDate(b.date)}, ${slotById(b.slot)?.time}. The slot will be released.`}
          onConfirm={() => onCancel(b.id)}
        >
          <button className="font-tech text-xs uppercase tracking-widest text-[#FF3333] hover:underline" data-testid={`admin-cancel-btn-${b.id}`}>Cancel</button>
        </CancelDialog>
      )}
    </TableCell>
  </TableRow>
);

export const BookingsTable = ({ bookings, onCancel }) => (
  <div className="surface overflow-x-auto" data-testid="admin-bookings-table">
    <Table>
      <TableHeader>
        <TableRow className="border-white/10 hover:bg-transparent">
          {["Date", "Session", "Space", "Customer", "Notes", "Status", ""].map((h) => (
            <TableHead key={h} className="font-tech text-[10px] uppercase tracking-[0.2em] text-zinc-500">{h}</TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {bookings.length === 0 ? (
          <TableRow><TableCell colSpan={7} className="py-12 text-center text-zinc-500" data-testid="admin-bookings-empty">No bookings match these filters.</TableCell></TableRow>
        ) : (
          bookings.map((b) => <Row key={b.id} b={b} onCancel={onCancel} />)
        )}
      </TableBody>
    </Table>
  </div>
);
